import { seo } from '../seo';
export { TransferDomainPage as default } from '../../src/pages/Product/TransferDomainPage';
export const meta = () => seo('domains.transfer');
